import { z } from 'zod'

export const SingleTicketStatusDtoSchema = z.union([z.literal('Active'), z.literal('Inactive'), z.literal('Used')])

export type SingleTicketStatusDto = z.infer<typeof SingleTicketStatusDtoSchema>

export const isSingleTicketStatusDto = (x: unknown): x is SingleTicketStatusDto =>
  SingleTicketStatusDtoSchema.safeParse(x).success
